var map = {
	"./dwc.png": 30532,
	"./lead_management.png": 3642,
	"./shopper_contact.png": 14746,
	"./smart_analytics.png": 76604,
	"./smart_leads.png": 46641,
	"./support.png": 48363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68975;